
import { Component, Vue } from 'vue-property-decorator'
import Checkbox from '~/components/common/Checkbox.vue'

@Component({
  name: 'CoregConsentCheckbox',
  components: {
    Checkbox
  }
})
export default class CoregConsentCheckbox extends Vue {
  checkboxState = false
}
